import React, {useState} from "react";
import {
  useNavigate,
  Link
} from 'react-router-dom';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';



import OpenJobFormPC from './OpenJobFormPC';
import OpenJobFormMobile from './OpenJobFormMobile';
import OpenJobFormTablet from './OpenJobFormTablet';



const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function OpenJobForm(props) {

   const quitStartFillingForm = () => {
     props.quitStartFillingForm();
   }

    return (

        <div style={{width: viewportWidth+'px'}}>

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <OpenJobFormPC quitStartFillingForm={quitStartFillingForm}/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
        	         <OpenJobFormMobile quitStartFillingForm={quitStartFillingForm}/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
        			     <OpenJobFormTablet quitStartFillingForm={quitStartFillingForm}/>
        			  </TabletView>
        			}

        </div>

    );




}
